import { render, staticRenderFns } from "./ManageApplications.vue?vue&type=template&id=54bb271c&"
import script from "./ManageApplications.vue?vue&type=script&lang=js&"
export * from "./ManageApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports